import { getMemberTransactions } from '../../../selectors/member/transactions/get-member-transactions';
import { loadMemberTransactions } from './load-member-transactions';
export const loadNextMemberTransactions = async (limit) => {
    const transactionList = getMemberTransactions();
    const offset = transactionList.length;
    await loadMemberTransactions({ limit, offset });
};
